import { render } from "./Breakdown.vue?vue&type=template&id=10771278&scoped=true"
import script from "./Breakdown.vue?vue&type=script&lang=js"
export * from "./Breakdown.vue?vue&type=script&lang=js"

import "./Breakdown.vue?vue&type=style&index=0&id=10771278&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10771278"]])

export default __exports__